<template>
  <span
    :class="
      twMerge(
        'tw:inline-flex tw:items-center tw:rounded tw:px-2 tw:py-0.5 tw:text-xs tw:font-medium',
        variant === 'filled' ? FILLED_CLASS : OUTLINED_CLASS,
        props.class
      )
    "
    data-testid="base-badge"
  >
    {{ label }}
    <slot />
  </span>
</template>

<script lang="ts">
export const FILLED_CLASS = "tw:bg-ai-secondary tw:text-white";
export const OUTLINED_CLASS = "tw:border tw:border-denim-300 tw:text-denim-600";
</script>

<script setup lang="ts">
import { twMerge } from "tailwind-merge";

interface BaseBadgeProps {
  class?: string;
  label: string;
  variant?: "filled" | "outlined";
}

const props = withDefaults(defineProps<BaseBadgeProps>(), {
  class: undefined,
  variant: "filled",
});
</script>
